var map = {
	"./Diana-27.jpeg": 4787,
	"./Diana.jpeg": 193,
	"./Luca-6.jpeg": 5778,
	"./kindle-10.jpeg": 9211,
	"./kindle-15.jpeg": 6656,
	"./lavanda-15-min.jpeg": 7083,
	"./lavanda-16-min.jpeg": 5934,
	"./lavanda-42-min.jpeg": 5395,
	"./lavanda-53-min.jpeg": 4957,
	"./lifestyle1.jpeg": 2612,
	"./lifestyle10.jpeg": 3708,
	"./lifestyle11.jpeg": 387,
	"./lifestyle12.jpeg": 8902,
	"./lifestyle13.jpeg": 6589,
	"./lifestyle14.jpeg": 7544,
	"./lifestyle15.jpeg": 9087,
	"./lifestyle16.jpeg": 4306,
	"./lifestyle17.jpeg": 4937,
	"./lifestyle18.jpeg": 1540,
	"./lifestyle19.jpeg": 4283,
	"./lifestyle2.jpeg": 7685,
	"./lifestyle20.jpeg": 4107,
	"./lifestyle21.jpeg": 8116,
	"./lifestyle22.jpeg": 3621,
	"./lifestyle3.jpeg": 5726,
	"./lifestyle4.jpeg": 7383,
	"./lifestyle5.jpeg": 6320,
	"./lifestyle6.jpeg": 7969,
	"./lifestyle7.jpeg": 5130,
	"./lifestyle8.jpeg": 371,
	"./lifestyle9.jpeg": 5116,
	"./new1.jpeg": 1083,
	"./new2.jpeg": 7038,
	"./new3.jpeg": 1669,
	"./new4.jpeg": 8528,
	"./new5.jpeg": 9447,
	"./olga14.jpeg": 6276,
	"./olga4.jpeg": 3371,
	"./revuele.jpeg": 1158,
	"./speak1.jpeg": 6792,
	"./speak2.jpeg": 350,
	"./zarea.jpeg": 2385
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7069;